import './SettingsSelect.scss'

import React, {Component} from 'react'

const classNames = require('classnames')

const SettingsSelect = (props) => {

  function renderRow(item) {

    function handleClick() {
      if (!item.disabled) {
        props.onClick(item.value, props.multiselect ? !props.selected[item.value] : null)
      }
    }

    let rowClasses = classNames({
      'SettingsSelect__item': true,
      'SettingsSelect__item--active': props.multiselect ? props.selected[item.value] : props.selected == item.value,
      'SettingsSelect__item--disabled': item.disabled,
      'clickable': !item.disabled,
    })

    let leftContent = props.leftAdditionalMap && item.value in props.leftAdditionalMap
    let labelClasses = classNames({
      'SettingsSelect__label': true,
      'SettingsSelect__left': leftContent
    })

    return (<div className={rowClasses} onClick={handleClick} key={item.value}>
        <i className="fa fa-check" aria-hidden="true"></i>
        {leftContent ? props.leftAdditionalMap[item.value] : null}
        <span className={labelClasses}>{ item.label }</span>
        {props.rightAdditionalMap && item.value in props.rightAdditionalMap ? props.rightAdditionalMap[item.value] : null}
      </div>)
  }

  return (
    <div className="SettingsSelect">
      { props.options.map(renderRow) }
    </div>)
}

export default SettingsSelect
